module.exports = __webpack_public_path__ + "static/img/develop.a5e0ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/develop.jpg
// module id = OR+k
// module chunks = 1